import React from "react";
import { useEffect, useState } from "react";
import axios from "../../MyAxios";
import Post from "../../components/Post";
import { GET_SAVED_POSTS } from "@constants/api";

const SavedPosts = () => {
  const [savedItems, setSavedItems] = useState([]);
  const [voteStatuses, setVoteStatuses] = useState({});

  useEffect(() => {
    if (!savedItems || savedItems.length === 0) return;

    const ids = savedItems
      .map((p) => p.postSaved)
      .filter(Boolean)
      .map((p) => {
        const isEvent =
          p.startTime ||
          p.endTime ||
          p.eventType ||
          String(p.id).startsWith("event-");

        return isEvent
          ? (String(p.id).startsWith("event-") ? p.id : `event-${p.id}`)
          : p.id;
      })
      .filter(Boolean);

    if (ids.length === 0) return;


    axios
      .post("/post/vote-status-bulk", {
        ids,
      })
      .then((res) => {
        setVoteStatuses((prev) => ({
          ...prev,
          ...res.data,
        }));
      })
      .catch((err) => {
        console.error("Failed to fetch bulk vote status", err);
      });

  }, [savedItems]);

  useEffect(() => {
    const getSavedItems = async () => {
      try {
        await axios.get(GET_SAVED_POSTS).then((res) => {
          setSavedItems(res.data);
          console.log(res.data);
        });
      } catch (error) { }
    };
    getSavedItems();
  }, []);

  const removePost = (id) => {
    setSavedItems(savedItems.filter((post) => post.id !== id));
  };
  return (
    <div>
      {(!savedItems || savedItems.length == 0) && <div className="my-10 text-center italic">No Posts To Show</div>}
      {savedItems.map((item, key) => {
        if (item.postSaved)
          return (
            <div key={key}>
              <Post
                post={item.postSaved}
                comment={false}
                removePost={() => removePost(item.id)}
                voteStatus={
                  voteStatuses[
                  item?.postSaved?.startTime || item?.postSaved?.eventType || String(item.postSaved.id).startsWith("event-")
                    ? `event-${item.postSaved.id.replace("event-", "")}`
                    : item.postSaved.id
                  ]
                }
              />
            </div>
          );
        else return null;
      })}
    </div>
  );
};

export default SavedPosts;
